module.exports = __webpack_public_path__ + "media/images/cut_h-6ef4df9b3b8e8e732178896d2701c319.png";